import type * as React from 'react'

import { ErrorState, Loading } from '@/components/states'
import type { LoadStatus } from '@/modules/projects/store-reducer'

/**
 * Carregando → erro → conteúdo. Nessa ordem, e antes de qualquer `Empty`.
 *
 * Sem isto, toda tela mostrava o estado vazio enquanto o banco respondia e
 * quando o banco recusava — "O Hub ainda está vazio, crie o primeiro projeto"
 * durante um carregamento é um convite a recadastrar o que já existe
 * (relatório §0 problema 6).
 */
export function StatusGate({
  status,
  onRetry,
  children,
}: {
  /** Um ou mais domínios; erro em qualquer um vence, carregando em qualquer um espera. */
  status: LoadStatus | readonly LoadStatus[]
  onRetry?: (() => void) | undefined
  children: React.ReactNode
}) {
  const list = Array.isArray(status) ? (status as readonly LoadStatus[]) : [status as LoadStatus]
  const failed = list.find((s): s is Extract<LoadStatus, { kind: 'erro' }> => s.kind === 'erro')
  if (failed) {
    return (
      <ErrorState
        title="Não foi possível carregar"
        description={failed.reason}
        {...(onRetry ? { onRetry } : {})}
      />
    )
  }
  if (list.some((s) => s.kind === 'carregando')) {
    return <Loading />
  }
  return <>{children}</>
}
